import { TableData } from "./table";

export interface ApiKey extends TableData {
    publicUuid: string;
    name: string;
    description: string;
    created: string;
    owner: string;
    expiration?: string;
    scope: ApiKeyScope;
}

export interface ApiKeysDto {
    public_uuid: string;
    name: string;
    description: string;
    created: string;
    owner: string;
    expiration?: string;
    // TODO BCC-5884 Remove once backend adds this.
    scope?: ApiKeyScope;
}

export interface ApiKeyCursor {
    publicUuid: string;
}

export interface ApiKeys extends TableData {
    api_keys: ApiKey[];
    cursor: ApiKeyCursor | null;
}

export interface ApiKeysData {
    apiKeys: ApiKeys;
}

export function toApiKey(dto: ApiKeysDto): ApiKey {
    return {
        publicUuid: dto.public_uuid,
        name: dto.name,
        description: dto.description,
        created: dto.created,
        owner: dto.owner,
        expiration: dto.expiration,
        // TODO BCC-5884 Remove once backend adds this.
        scope: dto.scope ?? "ALL",
    };
}

export interface ApiKeyDetail {
    publicUuid: string;
    name: string;
    description: string;
    created: string;
}

export interface GenerateApiKeyResponse {
    apiKey: string;
}

export function isApiKeyExpired(expiration?: string): boolean {
    if (!expiration) {
        return false;
    }
    const expirationDate = new Date(expiration).toISOString().split("T")[0];
    const today = new Date().toISOString().split("T")[0];
    return expirationDate <= today;
}

export const API_KEY_SCOPES = ["ALL", "ERASURE_CLIENT", "PUBLIC_API", "MCP"] as const;
export type ApiKeyScope = (typeof API_KEY_SCOPES)[number];

const SCOPE_TO_LOCALIZATION: Record<ApiKeyScope, string> = {
    ALL: "GenerateApiKeyForm.scopes.all",
    ERASURE_CLIENT: "GenerateApiKeyForm.scopes.erasureClient",
    PUBLIC_API: "GenerateApiKeyForm.scopes.publicApi",
    MCP: "GenerateApiKeyForm.scopes.mcp",
};

export function getApiKeyScopeLocalizationKey(scope: ApiKeyScope): string {
    return SCOPE_TO_LOCALIZATION[scope];
}
